export default __webpack_public_path__ + "static/B0206-0637d47fd788f5c6f661f9f45bcf2fa2.png";